import React, { type FC } from 'react';
import { isJsmVirtualAgentOnPortalEAPAvailable } from 'feature-flags';
import { graphql, useFragment } from 'react-relay';
import Avatar from '@atlaskit/avatar';
import { Message } from '@atlassian/help-center-conversation';
import type { helpseekerMessage$key } from './__generated__/helpseekerMessage.graphql';

export const HelpseekerMessage: FC<{ userRef: helpseekerMessage$key | undefined | null; messageContent: string }> = ({
    userRef,
    messageContent,
}) => {
    const data = useFragment<helpseekerMessage$key>(
        graphql`
            fragment helpseekerMessage on User {
                name
                picture
            }
        `,
        userRef
    );

    return (
        <Message
            backgroundColor={isJsmVirtualAgentOnPortalEAPAvailable() ? 'blue' : 'oldBlue'}
            content={messageContent}
            position="right"
            avatar={
                isJsmVirtualAgentOnPortalEAPAvailable() ? undefined : <Avatar src={data?.picture} name={data?.name} />
            }
        />
    );
};
